import { WithAuth } from "@/hoc";
import { usePayment } from "@/hooks/usePayment";
import {
    Flex, 
} from "@chakra-ui/react";
import { PageHeading } from "barte-design-system";
import BalanceCard from "./card-saldo";
import { DrawerNewPayment } from "./drawer-novo-pagamento";
import { PaymentsTable } from "./table-pagamentos";

function Pagamentos() {
    const { isNewPaymentDrawerOpen, onNewPaymentDrawerOpen, onNewPaymentDrawerClose } = usePayment();
    return (
        <>
            <DrawerNewPayment 
                isOpen={isNewPaymentDrawerOpen}
                onClose={onNewPaymentDrawerClose}
            />
            <Flex
                w="100%"
                h="100%"
                flexDir="column"
                gap="6"
            >
                <PageHeading
                    title="Contas a pagar"
                    primaryActionLabel="+ Novo pagamento"
                    onPrimaryAction={onNewPaymentDrawerOpen}
                />
                <BalanceCard />
                <PaymentsTable />
            </Flex>
        </>
    );
}

export default WithAuth(Pagamentos);
